import { render, staticRenderFns } from "./ItemSkeleton.vue?vue&type=template&id=2d716f35&scoped=true"
import script from "./ItemSkeleton.vue?vue&type=script&lang=js"
export * from "./ItemSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ItemSkeleton.vue?vue&type=style&index=0&id=2d716f35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d716f35",
  null
  
)

export default component.exports